import React, { Component } from 'react'
import fetch from 'isomorphic-fetch'

import AcervoLayout from '../../../templates/acervo'
import Actionresults from '../../components/Sections/Home/ActionResults'
import SearchProjects from '../../components/Sections/Home/SearchProjects'
import TableProjects from '../../components/Sections/Home/TableProjects'
import Paginator from '../../components/UI/Paginator/Paginator'
import { ACERVO_URL } from '../../../store/config'

class Acervo extends Component {

    state = {
        projects: [],
        years: [],
        modalities: [],
        states: [],
        municipalities: [],
        dataForm: {},
        pagination: {
            itemsCountPerPage: 10,
            activePage: 1,
            totalItemsCount: 0
        },
        wasFormSubmited: false,
        loadForm: false,
    }

    componentDidMount() {
        const { email, access_token } = this.props.session.user.profile
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'get'
        };

        const url = new URL(`${ACERVO_URL}/acervo/getSearchFilters`),
            params = { user_email: email }
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    return result.json();
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(response => {
                const { years, modalities, states, municipalities } = response
                this.setState({
                    years: years,
                    modalities: modalities,
                    states: states,
                    municipalities: municipalities
                })
            })
            .catch(console.log)
    }

    getMunicipalities = id => {
        const { access_token } = this.props.session.user.profile
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'get'
        };

        const url = new URL(`${ACERVO_URL}/municipalities`),
            params = { state_id: id }
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    return result.json();
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(response => {
                let municipalities = {}
                response.map(municipality => {
                    return municipalities[municipality.id] = municipality.name
                })
                this.setState({ municipalities: municipalities })
            })
            .catch(console.log)
    }

    updateDataForm = input => {
        let object = Object.assign({}, this.state.dataForm)
        object[input.name] = input.value
        this.setState({ dataForm: object })
    }

    handlerFormSubmit = (page = 1) => {
        this.setState({ loadForm: true })

        const { access_token } = this.props.session.user.profile
        const { itemsCountPerPage, activePage } = this.state.pagination
        const { dataForm } = this.state

        const params = {
            limit: itemsCountPerPage,
            page: activePage
        }
        
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'get'
        }

        const url = new URL(`${ACERVO_URL}/acervo/search`)
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
        Object.keys(dataForm).forEach(key => url.searchParams.append(key, dataForm[key]))

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    return result.json();
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(response => {
                const projects = response.data
                const { current_page, total } = response.meta

                let pagination = Object.assign({}, this.state.pagination)
                pagination['activePage'] = current_page
                pagination['totalItemsCount'] = total

                this.setState({ projects, pagination, wasFormSubmited: true, loadForm: false })
                
            })
            .catch(console.log)
    }

    handlerChangePage = page => {
        let pagination = Object.assign({}, this.state.pagination)
        pagination['activePage'] = page
        this.setState({ pagination }, function () {
            this.handlerFormSubmit(page)
        })

    }

    handlerChangeAction = input => {
        switch (input.name) {
            case 'itemsCountPerPage':
                let pagination = Object.assign({}, this.state.pagination)
                pagination['itemsCountPerPage'] = parseInt(input.value, 10)
                this.setState({ pagination: pagination }, function () {
                    this.handlerFormSubmit()
                })
                break;

            case 'actionDownload':
                const selectedProjects = document.getElementsByClassName('checkbox')

                let listProjects = []
                Array.prototype.forEach.call(selectedProjects, function (item) {
                    if (item.checked) {
                        listProjects.push(item.value)
                    }
                });

                this.hanlderDownloadProjects(listProjects, input.value)
                break;

            default:
                break;
        }
    }

    handlerDownloadSingleProject = (id, type) => {
        const { access_token } = this.props.session.user.profile
        const options = {
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'get',
        };

        let params = {
            id: id,
            type: type
        }

        let url = new URL(`${ACERVO_URL}/acervo/getProjectReport`)
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
        let fileName = undefined;
        let a = document.createElement("a");
        let objectURL;

        document.body.appendChild(a);
        a.style = "display: none";

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    let header = result.headers.get('Content-Disposition', 'attachment')
                    fileName = header.match(/filename="(.+)"/)[1];
                    return result.blob()
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(blob => {
                objectURL = URL.createObjectURL(blob);
                a.href = objectURL;
                a.download = fileName
                a.click();
                window.URL.revokeObjectURL(objectURL);
            })
            .catch(console.log)
    }

    hanlderDownloadProjects = (ids, type) => {
        const { access_token } = this.props.session.user.profile

        let url = new URL(`${ACERVO_URL}/acervo/getReport`)
        const params = {
            ids: ids.toString(),
            type: type
        }

        const options = {
            headers: {
                'Authorization': `Bearer ${access_token}`
            },
            method: 'get',
            responseType: 'blob'
        };

        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
        let fileName = undefined;
        let a = document.createElement("a");
        let objectURL;

        document.body.appendChild(a);
        a.style = "display: none";

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {
                    let header = result.headers.get('Content-Disposition', 'attachment')
                    fileName = header.match(/filename="(.+)"/)[1];
                    return result.blob()
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(blob => {
                objectURL = URL.createObjectURL(blob);
                a.href = objectURL;
                a.download = fileName
                a.click();
                window.URL.revokeObjectURL(objectURL);
            })
            .catch(console.log)
    }

    render() {
        const { projects, years, modalities, states, municipalities, wasFormSubmited, loadForm } = this.state
        const { itemsCountPerPage, totalItemsCount, activePage } = this.state.pagination

        return (
            <div className="columns is-multiline is-centered is-home">
                <div className="column is-10">
                    <h2 className='is-size-4'>Busca tu proyecto</h2>
                </div>
                <div className="column is-10">
                    <SearchProjects
                        years={years}
                        modalities={modalities}
                        states={states}
                        municipalities={municipalities}
                        onChangeState={this.getMunicipalities}
                        updateDataForm={this.updateDataForm}
                        onSubmit={this.handlerFormSubmit}
                        loadForm={loadForm}
                    />
                </div>
                <div className="column is-10">
                    <Actionresults
                        onChange={this.handlerChangeAction}
                        show={projects.length > 0}
                    />
                </div>
                <div className="column is-10">
                    <TableProjects
                        projects={projects}
                        onclickDownload={this.handlerDownloadSingleProject}
                        wasFormSubmited={wasFormSubmited}
                    />
                </div>
                <div className="column is-12">
                    <Paginator
                        itemsCountPerPage={itemsCountPerPage}
                        totalItemsCount={totalItemsCount}
                        activePage={activePage}
                        onChange={this.handlerChangePage}
                    />
                </div>
            </div>
        )
    }
}

export default AcervoLayout(Acervo, {
    title: 'Acervo',
    subnav: {
        icon: 'fa-briefcase',
        name: 'Acervo',
        actions: [
        ]
    },
    stateNav: false,
    progress: false
})


// WEBPACK FOOTER //
// ./src/acervo/containers/Home/Home.js